const GoogleMapsBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.032"
    height="22"
    viewBox="0 0 24.032 22"
  >
    <path fill="#fff" d="M2 12h20.032v8H2z" />
    <path d="M0 10v12h24.032V10zm22.032 10H2v-8h20.032z" fill="#333" />
    <path
      d="M12.016 12.903c2.12-2.651 4-5.628 4-6.903a4 4 0 0 0-8 0c0 1.275 1.88 4.252 4 6.903z"
      fill="#ffd400"
    />
    <path
      d="M12.016 0a6 6 0 0 0-6 6c0 3.314 6 10 6 10s6-6.686 6-10a6 6 0 0 0-6-6zm0 2a4.005 4.005 0 0 1 4 4c0 1.275-1.88 4.252-4 6.903-2.12-2.651-4-5.628-4-6.903a4.005 4.005 0 0 1 4-4z"
      fill="#333"
    />
    <circle cx="12.016" cy="6" r="2" fill="#333" />
  </svg>
);

export default GoogleMapsBlockIcon;
